module.exports = __webpack_public_path__ + "5e6ca7227e00e4baaaa70a01e6b5ae18.svg";